// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    call,
    put,
} from 'redux-saga/effects';

import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import {
    GET_DEVICE_ELIGIBILITY_DATA,
    getDeviceEligibilityDataFail,
    getDeviceEligibilityDataSuccess,
} from './../../../store/deviceInfo/eligibility';

import DeviceDal from './../../../dal/DeviceDal';

export function* fetchDeviceEligibility(request: any): IterableIterator<any> {
    const {
        customerId,
        country,
        serialNumber,
        zipCode,
        agentTier,
    } = request.payload;

    try {
        yield put(actionStatusStarted({ actionName: GET_DEVICE_ELIGIBILITY_DATA }));
    
        const eligibility = yield call(DeviceDal.getEligibility, {
            country,
            serialNumber,
            zipCode,
            agentTier,
        });

        yield put(actionStatusSuccess({ actionName: GET_DEVICE_ELIGIBILITY_DATA }));
        yield put(getDeviceEligibilityDataSuccess(eligibility));
    } catch (e) {
        yield put(actionStatusFailed({
            actionName: GET_DEVICE_ELIGIBILITY_DATA,
            data: {
                country,
                serialNumber,
                zipCode,
                customerId,
            },
            error: e,
        }));
        yield put(getDeviceEligibilityDataFail(e));
    }
}
